var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#ddd",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3025 4798 c-27 -10 -497 -380 -573 -452 -19 -17 -40 -44 -49 -60 -18 -34 -19 -116 -2 -148 36 -67 380 -577 405 -600 62 -56 167 -57 226 -1 47 45 61 79 56 142 -4 50 -13 70 -86 181 -67 103 -78 126 -64 128 29 5 251 -72 356 -122 228 -110 460 -301 617 -511 397 -528 446 -1250 123 -1827 -246 -438 -674 -746 -1169 -840 -171 -32 -439 -32 -610 0 -704 133 -1243 686 -1362 1395 -11 69 -17 158 -17 272 1 255 39 439 141 675 56 129 60 179 19 240 -50 76 -143 99 -226 58 -41 -21 -50 -33 -95 -123 -100 -200 -165 -448 -187 -712 -27 -331 42 -703 189 -1013 171 -362 464 -684 806 -884 376 -221 818 -319 1237 -276 805 84 1483 629 1735 1395 122 369 134 767 35 1149 -34 134 -61 205 -134 361 -195 412 -536 754 -951 955 -117 57 -323 132 -397 146 -21 3 -38 9 -38 13 0 4 47 47 105 94 57 47 111 97 120 111 39 58 31 147 -18 203 -51 58 -120 77 -192 51z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset);
export default __webpack_public_path__ + "static/media/Reset.74b8c6484948db7f44431d0179926a02.svg";
export { ForwardRef as ReactComponent };